import {
  MONTHLY_INCOME_CONFIG,
  REQUESTED_AMOUNT_CONFIG,
} from 'constants/digitalLoanQuestionnaire';

export function createInitialQuestionnaire() {
  return {
    locationType: '',
    companyOrBusinessName: '',
    locationPostalCode: '',
    coordinates: null,
    requestedAmount: REQUESTED_AMOUNT_CONFIG.initial,
    paymentFrequency: '',
    paymentTerm: null,
    address: {
      street: '',
      exteriorNumber: '',
      interiorNumber: '',
      postalCode: '',
      state: '',
      stateName: '',
      municipality: '',
      municipalityName: '',
      colony: '',
      colonyName: '',
      yearsAtAddress: '',
    },
    proofOfAddress: null,
    rfc: '',
    curp: '',
    monthlyIncome: MONTHLY_INCOME_CONFIG.initial,
  };
}
